<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />
    <b-row>
      <b-col sm="12" md="12">
        <b-card header-tag="header">
          <div slot="header">
            <strong>{{ titulo }}</strong>
          </div>
          <keep-alive>
            <indice-declaracion
              v-if="componente === 0"
              :puesto="puesto"
              :declaracion="basico"
              :generales="generalesIndice"
              @verSeccion="verSeccion($event)"
            />

            <formulario-1
              v-if="componente === 1"
              :generales="generales"
              :status="basico.status"
              @verSeccion="verSeccion($event)"
            />

            <formulario-2
              v-if="componente === 2"
              :domicilio="domicilio"
              :status="basico.status"
              @verSeccion="verSeccion($event)"
            />

            <formulario-3
              v-if="componente === 3"
              :curriculo="curriculo"
              :status="basico.status"
              @verSeccion="verSeccion($event)"
            />

            <formulario-4
              v-if="componente === 4"
              :cargo="cargo"
              :status="basico.status"
              :tipoDeclaracion="generalesIndice.tipo"
              @verSeccion="verSeccion($event)"
              
            />
            <formulario-5
              v-if="componente === 5"
              :laboral="laboral"
              :status="basico.status"
              @verSeccion="verSeccion($event)"
            />

            <formulario-6
              v-if="componente === 6"
              :pareja="pareja"
              :status="basico.status"
              @verSeccion="verSeccion($event)"
            />

            <formulario-7
              v-if="componente === 7"
              :status="basico.status"
              :tipo="tipo"
              :depe="depe"
              @verSeccion="verSeccion($event)"
            />

            <formulario-8
              v-if="componente === 8"
              :status="basico.status"
              :ingresos="ingresos"
              :tipoDeclaracion="generalesIndice.tipo"
              :puesto="puesto"
              @verSeccion="verSeccion($event)"
            />

            <formulario-85
              v-if="componente === 8.5"
              :status="basico.status"
              :actividadAnualAnterior="actividadAnualAnterior"
              :tipoDeclaracion="generalesIndice.tipo"
              :puesto="puesto"
              @verSeccion="verSeccion($event)"
            />

            <formulario-9
              v-if="componente === 9"
              :status="basico.status"
              :inmuebles="inmuebles"
              :tipo="tipo"
              @verSeccion="verSeccion($event)"
            />

            <formulario-10
              v-if="componente === 10"
              :status="basico.status"
              :vehiculos="vehiculos"
              @verSeccion="verSeccion($event)"
            />

            <formulario-11
              v-if="componente === 11"
              :muebles="muebles"
              :status="basico.status"
              @verSeccion="verSeccion($event)"
            />

            <formulario-12
              v-if="componente === 12"
              :valores="valores"
              :tipoDeclaracion="generalesIndice.tipo"
              :status="basico.status"
              @verSeccion="verSeccion($event)"
            />

            <formulario-13
              v-if="componente === 13"
              :adeudos="adeudos"
              :tipo="tipo"
              :status="basico.status"
              @verSeccion="verSeccion($event)"
            />

            <formulario-14
              v-if="componente === 14"
              :participacion="participacion"
              :status="basico.status"
              @verSeccion="verSeccion($event)"
            />

            <formulario-15
              v-if="componente === 15"
              :status="basico.status"
              :decisiones="decisiones"
              @verSeccion="verSeccion($event)"
            />

            <formulario-16
              v-if="componente === 16"
              :status="basico.status"
              :prestamoComodato="prestamoComodato"
              @verSeccion="verSeccion($event)"
            />

            <formulario-17
              v-if="componente === 17"
              :apoyo="apoyo"
              :status="basico.status"
              @verSeccion="verSeccion($event)"
            />
            <formulario-18
              v-if="componente === 18"
              :representacion="representacion"
              :status="basico.status"
              @verSeccion="verSeccion($event)"
            />

            <formulario-19
              v-if="componente === 19"
              :clientesPrincipales="clientesPrincipales"
              :status="basico.status"
              @verSeccion="verSeccion($event)"
            />

            <formulario-20
              v-if="componente === 20"
              :status="basico.status"
              :beneficiosPrivados="beneficiosPrivados"
              @verSeccion="verSeccion($event)"
            />

            <formulario-21
              v-if="componente === 21"
              :fideicomisos="fideicomisos"
              :status="basico.status"
              @verSeccion="verSeccion($event)"
            />
          </keep-alive>
        </b-card>
      </b-col>
    </b-row>
    <!--/.row-->
  </div>
</template>

<script>
import IndiceDeclaracion from "../../components/declaraciones/formulariosV2/IndiceDeclaracion";
import Formulario1 from "../../components/declaraciones/formulariosV2/formulario1";
import Formulario2 from "../../components/declaraciones/formulariosV2/formulario2";
import Formulario3 from "../../components/declaraciones/formulariosV2/formulario3";
import Formulario4 from "../../components/declaraciones/formulariosV2/formulario4";
import Formulario5 from "../../components/declaraciones/formulariosV2/formulario5";
import Formulario6 from "../../components/declaraciones/formulariosV2/formulario6";
import Formulario7 from "../../components/declaraciones/formulariosV2/formulario7";
import Formulario8 from "../../components/declaraciones/formulariosV2/formulario8";
import Formulario85 from "../../components/declaraciones/formulariosV2/formulario8-5";
import Formulario9 from "../../components/declaraciones/formulariosV2/formulario9";
import Formulario10 from "../../components/declaraciones/formulariosV2/formulario10";
import Formulario11 from "../../components/declaraciones/formulariosV2/formulario11";
import Formulario12 from "../../components/declaraciones/formulariosV2/formulario12";
import Formulario13 from "../../components/declaraciones/formulariosV2/formulario13";
import Formulario14 from "../../components/declaraciones/formulariosV2/formulario14";
import Formulario15 from "../../components/declaraciones/formulariosV2/formulario15";
import Formulario16 from "../../components/declaraciones/formulariosV2/formulario16";
import Formulario17 from "../../components/declaraciones/formulariosV2/formulario17";
import Formulario18 from "../../components/declaraciones/formulariosV2/formulario18";
import Formulario19 from "../../components/declaraciones/formulariosV2/formulario19";
import Formulario20 from "../../components/declaraciones/formulariosV2/formulario20";
import Formulario21 from "../../components/declaraciones/formulariosV2/formulario21";

import axios from "axios";
import Loader from "../Loader";

import { mapGetters } from "vuex";

export default {
  components: {
    Loader,
    IndiceDeclaracion,
    Formulario1,
    Formulario2,
    Formulario3,
    Formulario4,
    Formulario5,
    Formulario6,
    Formulario7,
    Formulario8,
    Formulario85,
    Formulario9,
    Formulario10,
    Formulario11,
    Formulario12,
    Formulario13,
    Formulario14,
    Formulario15,
    Formulario16,
    Formulario17,
    Formulario18,
    Formulario19,
    Formulario20,
    Formulario21
  },
  computed: {
    ...mapGetters(["httpURL", "sessionToken"]),
    
  },
  data: function() {
    return {
      titulo: this.$route.name,
      puesto:null,
      enviando: false,
      componente: 0,
      declaracion: null,
      basico: {},
      generales: {},
      generalesIndice: {},
      domicilio: {},
      laboral: [],
      permisoPublico: {},
      dependientes: [],
      cargo: {},
      depe: {},
      ingresos: {},
      inmuebles: {},
      vehiculos: {},
      muebles: {},
      valores: {},
      adeudos: {},
      participacion: {},
      observaciones: null,
      decisiones: {},
      tipo: "",
      prestamoComodato: {},
      apoyo: {},
      representacion: {},
      actividadAnualAnterior: {},
      clientesPrincipales: {},
      beneficiosPrivados: {},
      fideicomisos: {},
      sta:null,
      
    };
  },
  created() {
    //Se obtienen misDeclaraciones

    this.enviando = true;
    axios
      .get(
        this.httpURL + "/declaraciones/V2/consulta/" + this.$route.params.id,
        { headers: { token: this.sessionToken } }
      )
      .then(res => {
       //console.log(res.data);
       this.puesto = res.data.puesto;
        this.sta=res.data.generales.status;
          this.declaracion = res.data.declaracion;
        (this.basico = {
          status: res.data.generales.status,
          tipo: res.data.generales.tipo,
          recepcion: null,
          conclusion: res.data.generales.conclusion,
          // consecutivo: this.declaracion.consecutivo ? this.declaracion.consecutivo : 0
          consecutivo: 0
        }),
        (this.generalesIndice = res.data.generales);
        this.generales = res.data.declaracion.situacionPatrimonial.datosGenerales;
        this.domicilio = res.data.declaracion.situacionPatrimonial.domicilioDeclarante;
        this.curriculo = res.data.declaracion.situacionPatrimonial.datosCurricularesDeclarante;
        this.laboral = res.data.declaracion.situacionPatrimonial.experienciaLaboral;
        this.pareja = res.data.declaracion.situacionPatrimonial.datosPareja;
        this.cargo = res.data.declaracion.situacionPatrimonial.datosEmpleoCargoComision;
        this.depe =  res.data.declaracion.situacionPatrimonial.datosDependientesEconomicos;
        this.ingresos = res.data.declaracion.situacionPatrimonial.ingresos;
        this.decisiones = res.data.declaracion.intereses.participacionTomaDecisiones;
        this.apoyo = res.data.declaracion.intereses.apoyos;
        this.inmuebles = res.data.declaracion.situacionPatrimonial.bienesInmuebles;
        this.vehiculos = res.data.declaracion.situacionPatrimonial.vehiculos;
        this.valores = res.data.declaracion.situacionPatrimonial.inversionesCuentasValores;
        this.representacion = res.data.declaracion.intereses.representaciones;
        this.participacion = res.data.declaracion.intereses.participacion;
        this.observaciones = res.data.declaracion.observaciones;
        this.enviando = false;
        this.muebles = res.data.declaracion.situacionPatrimonial.bienesMuebles;
        this.adeudos = res.data.declaracion.situacionPatrimonial.adeudosPasivos;
        this.actividadAnualAnterior = res.data.declaracion.situacionPatrimonial.actividadAnualAnterior;
        this.prestamoComodato = res.data.declaracion.situacionPatrimonial.prestamoComodato;
        this.clientesPrincipales = res.data.declaracion.intereses.clientesPrincipales;
        this.beneficiosPrivados = res.data.declaracion.intereses.beneficiosPrivados;
        this.fideicomisos = res.data.declaracion.intereses.fideicomisos;
        this.tipo = res.data.generales.tipo; //tipo de declaracion
       
      })
      .catch(error => {
       // console.log(error);
        if (error.response) {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: error.response.data.mensaje
          });
        } else if (error.request) {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 1500,
            speed: 1000,
            text: "No se pudo establecer una conexión al servidor."
          });
        }
        this.enviando = false;
        this.$router.go(-1);
      });
  },
  methods: {
    verSeccion(sec,status) {
    
      this.componente = sec;
      this.status=status;
    }
  }
};
</script>
